import { AlphaGIcon } from './AlphaGIcon';

/**
 * author: GreenTurtwig
 * id 4B7C3083-DFDF-402E-9D71-CABE04305297
 * name alpha-g
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-g.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetGIcon = AlphaGIcon;
export default AlphabetGIcon